module.exports = __webpack_public_path__ + "static/media/play-button-white-bg.96fb5e43.png";